import { render, staticRenderFns } from "./SendHistory.vue?vue&type=template&id=fed310be"
import script from "./SendHistory.vue?vue&type=script&lang=js"
export * from "./SendHistory.vue?vue&type=script&lang=js"
import style0 from "./SendHistory.vue?vue&type=style&index=0&id=fed310be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports